/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useRef } from "react";
import { Col, Image, Modal, Row, Table, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  newsSelector,
  storeProductSelector,
} from "../../../services/selector/index.";
import {
  IconEdit,
  IconEye,
  IconLock,
  IconNext,
  IconPlus,
  IconPolygon,
  IconPre,
  IconSpin,
  IconXmark,
} from "../../../assets/icon";
import "../../../assets/style/table/product.scss";
import { useState } from "react";
import { useMemo } from "react";
import { setOpenPUDelete } from "../../../services/slice/PopUpSlice";
import TranslateText from "../TranslateText";
import { formatPrice } from "../../../utils/functionCommon";
import { renameStatusProduct } from "../../../utils/convertNumber";
import {
  addFirstPageStore,
  getAllProduct,
  getLogProduct,
  setOpenEditProduct,
  setOpenModalAddProduct,
  setOpenModalConfirm,
  setPageProduct,
  setSearchText,
  setStatusProduct,
} from "../../../services/slice/StoreSlice";
import { useTranslation } from "react-i18next";
import InputSearchBox from "../Input/InputSearchBox";
import SelectValue from "../Selector/SelectValue";
import BaseButton from "../Button/BaseButton";
import { valueSelectStatusProduct } from "../../../utils/ValueSelect";

const TableStore = ({ setShowPreview }) => {
  const dispatch = useDispatch();
  const storeState = useSelector(storeProductSelector);
  const { data, total, callBackRequest, config, dataBasePageOne } = storeState;
  const [page, setPage] = useState(0);
  const { t } = useTranslation();
  const [rightClick, setRightClick] = useState({
    isOpen: false,
    x: "",
    y: "",
    value: "",
  });
  const dataSource = useMemo(() => {
    const result = data?.map((item, index) => {
      return {
        ...item,
        STT: total > 10 && page >= 2 ? (page - 1) * 10 + index + 1 : index + 1,
        key: item.id,
        price: formatPrice(item.price),
        status: t(renameStatusProduct(item.status)),
      };
    });
    return result;
  }, [data, page, total, t]);

  useEffect(() => {
    if (callBackRequest) {
      dispatch(getAllProduct());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [callBackRequest]);
  useEffect(() => {
    dispatch(getAllProduct(storeState.config));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeState.config]);

  const handleShowModalDelete = (value) => {
    dispatch(
      setOpenPUDelete({ stateOpen: true, content: value.title, id: value.id })
    );
  };

  const handleShowEditModal = (value) => {
    dispatch(setOpenEditProduct({ isOpen: true, id: value.id }));
  };

  const columns = [
    {
      title: "STT",
      dataIndex: "STT",
      key: "STT",
      className: "centerCell",
    },
    {
      title: <TranslateText text="Ảnh sản phẩm" />,
      dataIndex: "urlImage",
      key: "urlImage",
      className: "centerCell imgTable",
      render: (text, record) => (
        <Image
          style={{
            display: "block",
            objectFit: "contain",
          }}
          src={`${window.SERVER_URL}/${text}`}
          alt={`Image ${record.name}`}
          width={150}
          height={70}
        />
      ),
    },
    {
      title: <TranslateText text="Mã sản phẩm" />,
      dataIndex: "code",
      key: "code",
      className: "centerCell",
    },
    {
      title: <TranslateText text="Tên sản phẩm" />,
      dataIndex: "name",
      key: "name",
      className: "title collapseText centerCell",
    },

    {
      title: <TranslateText text="Giá gốc" />,
      dataIndex: "price",
      key: "price",
      className: "centerCell",
    },
    {
      title: <TranslateText text="Giá ưu đãi" />,
      dataIndex: "priceDrop",
      key: "priceDrop",
      className: "centerCell",
      render: (text, record) => <span>{formatPrice(text)}</span>,
    },

    {
      title: <TranslateText text="Tình trạng" />,
      dataIndex: "status",
      key: "status",
      className: "centerCell",
      render: (text, record) => {
        return (
          <div className="statusProduct" style={{ minWidth: 100 }}>
            <p
              className="textStatus"
              style={{ color: text === t("Còn hàng") ? "green" : "red" }}
            >
              {text}
              <span className="iconChange">
                <IconPolygon />
              </span>
              <ul className="list">
                <li
                  className="item"
                  onClick={() =>
                    text !== "Hết hàng"
                      ? dispatch(
                          setOpenModalConfirm({
                            isOpen: true,
                            content: t(text),
                            id: record.id,
                          })
                        )
                      : null
                  }
                >
                  Hết hàng
                </li>
                <li
                  className="item"
                  onClick={() =>
                    text !== "Còn hàng"
                      ? dispatch(
                          setOpenModalConfirm({
                            isOpen: true,
                            content: t(text),
                            id: record.id,
                          })
                        )
                      : null
                  }
                >
                  Còn hàng
                </li>
              </ul>
            </p>
          </div>
        );
      },
    },
    {
      title: <TranslateText text="Chức năng" />,
      key: "action",
      dataIndex: "action",
      className: "centerCell m10",
      render: (text, record) => {
        return (
          <div className="centerCell" style={{ minWidth: "120px" }}>
            <span
              className="pointer iconTbl "
              onClick={() => dispatch(getLogProduct(record.id))}
            >
              <Tooltip title="Xem log">
                <IconLock />
              </Tooltip>
            </span>
            <span
              className="pointer iconTbl"
              onClick={() => handleShowEditModal(record)}
              style={{ marginRight: "1rem" }}
            >
              <Tooltip title="Chỉnh sửa">
                <IconEdit />
              </Tooltip>
            </span>
            <span
              className="pointer iconTbl"
              onClick={() => handleShowModalDelete(record)}
            >
              <Tooltip title="Xóa">
                <IconXmark />
              </Tooltip>
            </span>
          </div>
        );
      },
    },
  ];
  const tableLoading = {
    spinning: storeState.isLoading, // isLoading là biến boolean để xác định xem có đang loading hay không
    indicator: <IconSpin className="iconSpin" />,
  };
  const handleRightClick = (e, record) => {
    e.preventDefault();
    setRightClick({
      isOpen: true,
      x: e.clientX,
      y: e.clientY - 70,
      value: record,
    });
  };
  // const rowClassName = (record) => {
  //   return record.statusPin ? "marked-row" : "";
  // };
  return (
    <>
      {rightClick.isOpen ? (
        <ModalRightClick
          top={rightClick.y}
          left={rightClick.x}
          setOpen={setRightClick}
          value={rightClick.value}
        />
      ) : null}
      <Row style={{ width: "100%" }}>
        <Col className="mr-5">
          <InputSearchBox
            setText={(value) => {
              dispatch(setSearchText(value));
            }}
            width={435}
            placeholder={"Tìm kiếm theo tên sản phẩm"}
          />
        </Col>
        <Col>
          <SelectValue
            optionsValue={valueSelectStatusProduct}
            width={165}
            defaultValue={t("Tình trạng")}
            type="selectGray"
            handleChange={(value) => dispatch(setStatusProduct(value))}
          />
        </Col>

        <Col style={{ flexGrow: 1, display: "flex", justifyContent: "end" }}>
          <BaseButton
            handleClick={() => setShowPreview(true)}
            width={120}
            typeBtn={"btnOrange"}
            icon={
              <IconEye
                width={16}
                height={14}
                fill="white"
                style={{ marginRight: "0.5rem" }}
              />
            }
            content={`Xem trước`}
          />
        </Col>
        <Col className="ml-5">
          <BaseButton
            handleClick={() => dispatch(setOpenModalAddProduct(true))}
            width={120}
            typeBtn={"btnOrange"}
            icon={
              <IconPlus
                width={16}
                height={14}
                style={{ marginRight: "0.5rem" }}
              />
            }
            content={`Thêm mới`}
          />
        </Col>
      </Row>
      <Row style={{ width: "100%" }}>
        <Table
          onRow={(record, index) => ({
            onContextMenu: (event) => handleRightClick(event, record),
          })}
          // rowClassName={rowClassName}
          loading={tableLoading}
          className="wrapperTblProduct"
          style={{ width: "100%", marginTop: "2.6rem" }}
          columns={columns}
          dataSource={dataSource}
          pagination={
            total > 10
              ? {
                  onChange: (value) => {
                    setPage(value);
                    dispatch(setPageProduct(value));
                  },
                  total,
                  pageSize: 10,
                  current: config.option.offset,
                  prevIcon: <IconPre />,
                  nextIcon: <IconNext />,
                  showSizeChanger: false,
                }
              : false
          }
        />
      </Row>
    </>
  );
};

export default TableStore;

const ModalRightClick = ({ top, left, setOpen, value }) => {
  const puRef = useRef();
  const storeState = useSelector(storeProductSelector);
  const { dataBasePageOne } = storeState;
  const dispatch = useDispatch();
  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setOpen(false);
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }
  useOutsideAlerter(puRef);
  const handleClick = () => {
    if (dataBasePageOne.find((item) => item.id === value.id)) {
      Modal.error({
        className: "wrapperModalErrConfigBanner",
        centered: true,
        width: 590,
        title: <span style={{ fontSize: 20, fontWeight: 700 }}>Lỗi</span>,
        content: (
          <>
            <p style={{ fontSize: 20 }}>
              Sản phẩm đã có trong danh sách. Vui lòng thử lại.
            </p>
          </>
        ),
      });
      return;
    }
    if (dataBasePageOne.length >= 8) {
      Modal.error({
        className: "wrapperModalErrConfigBanner",
        centered: true,
        width: 590,
        title: <span style={{ fontSize: 20, fontWeight: 700 }}>Lỗi</span>,
        content: (
          <>
            <p style={{ fontSize: 20 }}>Tối đa có 8 sản phẩm</p>
          </>
        ),
      });
      return;
    }
    setOpen(false);
    dispatch(addFirstPageStore({ id: value.id }));
  };
  return (
    <div
      onClick={handleClick}
      ref={puRef}
      style={{ position: "absolute", top: top, left: left, minWidth: 200 }}
      className="btnAddToPageOne"
    >
      Thêm vào <span>Trang 1</span>
    </div>
  );
};
